<script>

export default {
  name: 'nx-searcher-filter',
  components: {},
  props: {
    filter: {
      type: String,
      required: true,
    },
    value: {
      type: [Array, String, Number],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    default: {
      type: [Array, String, Number],
    },
  },
  methods: {
    /**
     * @param {any} value
     * @param {boolean} silent - don't push a new router state, useful on default initial filter updates
     */
    updateFilter(value, silent = false) {
      this.$emit('input', this.filter, value, silent);
    },
  },
  watch: {
    value: {
      handler(newVal) {
        if (!newVal && this.default) {
          this.updateFilter(this.default, true);
        }
      },
      immediate: true,
    },
  },
};
</script>
